import React from "react";
import Sidebar from "../../Components/Layout/Sidebar";


const RootLayout = () => {
    return (
        <>
            <Sidebar />
        </>
    )


}


export default RootLayout;